<template>
    <div class="vm-goal" :class="{on: is_reached}">
        <template v-if="is_show_sum_info">
            <div v-if="is_show_income" class="fs20 lh1 purple">{{goal.sum_income}} {{$t('c.Goal.text1')}}</div>
            <div v-else class="fs20 lh1 purple">{{goal.sum_fans}} {{$t('c.Goal.text2')}}</div>
            <div class="flex-box mt8 flex-justify-content-space-between mb24 fs12">
                <span class="black-8">{{$t('c.Goal.text3')}}</span>
                <div>
                    <span  v-if="is_show_income" class="black-3">{{goal.sum_fans}}{{$t('c.Goal.text4')}}</span>
                    <span class="black-3 ml8">{{goal.days_left}}</span>
                </div>
            </div>
        </template>
        <div class="tit" v-if="goal.type == goal_type.sum_income">
          <span class="" v-if="this.user && this.user.user_id != '4007c25ca93511ebb25452540025c377'">{{goal.monthly_income}} {{$t('c.Goal.text5')}}</span>
          <template v-if="!is_reached">
              <span class="purple" :class="{ml16: this.user && this.user.user_id != '4007c25ca93511ebb25452540025c377'}">{{(goal.percent * 100).toFixed(2)}} %</span>
          </template>
          <template v-if="is_reached">
              <span class="reached ml16">{{$t('c.Goal.text6')}}</span>
              <i class="afd afd-reached reached ml8"></i>
          </template>
        </div>
        <div class="tit" v-if="goal.type == goal_type.sponsor">
            <template v-if="!is_reached">
                <span class="purple">{{user.creator.monthly_fans}}</span> /
            </template>
            {{goal.monthly_fans}} {{$t('c.Goal.text7')}}
            <template v-if="is_reached">
                <span class="reached ml16">{{$t('c.Goal.text8')}}</span>
                <i class="afd afd-reached reached ml8"></i>
            </template>
        </div>
        <div class="tit" v-if="goal.type == goal_type.money">
            <template v-if="is_show_income">
                <template v-if="!is_reached">
                    <span class="purple">{{goal.sum_income}}</span> /
                </template>
                {{goal.monthly_income}} {{$t('c.Goal.text9')}} <span class="black-5">{{$t('c.Goal.text10')}}</span>
            </template>
            <template v-else>
                <span class="purple">{{(goal.percent * 100).toFixed(1)}} </span>%
            </template>
            <template v-if="is_reached">
                <span class="reached ml16">{{$t('c.Goal.text11')}}</span>
                <i class="afd afd-reached reached ml8"></i>
            </template>
        </div>
        <div class="bar-box mt8">
            <div class="bar" :style="{width: percent + '%'}"></div>
        </div>
        <pre-box class="mt8 desc fs12" :text="goal.desc"></pre-box>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'goal',
    props: {
        goal:{
            type:Object,
            default(){
                return {}
            },
        },
        user:{
            type:Object,
            default(){
                return {}
            },
        },
        is_show_sum_info:{
            default(){
                return false;
            },
        },

    },
    components:{
    },
    data() {
        return {
        }
    },
    computed:{
        ...mapState('app',[
            'goal_type',
            'goal_status',
            'session_user',
        ]),
        is_show_income(){
            return this.user && this.user.creator.privacy_public_income
        },
        percent(){
            let result = ''
            if(this.goal.type == this.goal_type.sum_income){
                return this.goal.percent * 100
            }
            if(!this.is_show_income){
                return this.goal.percent * 100
            }
            if(this.goal.type == this.goal_type.sponsor){
                result = this.user.creator.monthly_fans / this.goal.monthly_fans * 100;
            }
            if(this.goal.type == this.goal_type.money){
                // result = this.user.creator.monthly_income / this.goal.monthly_income * 100;
                return this.goal.percent * 100
            }
            return isNaN(result) ? '0' : result
        },
        is_reached(){
            if(!this.is_show_income){
                return this.goal.percent >= 1
            }
            return this.percent >= 100
        }
    },
    mounted() {
    },
    methods: {

    }
};
</script>

<style lang="stylus" scoped>
.vm-goal{
    &.on{
        .bar-box{
            display none
        }
        .desc,
        .tit{
            color $black-5
        }
    }
    .reached{
        color #5DD975
    }
    .desc{
        color $black-8
    }
    .bar-box{
        height px2rem(4)
        position relative
        background $black-1
        border-radius px2rem(2)
        .bar{
            position absolute
            left 0
            top 0
            background $purple
            height px2rem(4)
            width 50%
            border-radius px2rem(2)
        }
    }
}
</style>
